import type { Model } from '@patsnap/tahiti-core/common/model';
import type { TranslationSettings } from '../types';

export const TranslationSettingModel = Symbol.for('TranslationSettingModel');

export interface TranslationSettingModel extends Model<TranslationSettings> {}
